import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import { useParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reusable/Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditRiderInvoiceComponent = loadable(
  () => import("../../components/RiderInvoice/EditRiderInvoice")
);

const EditRiderInvoice = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetHook({
    queryKey: [`rider-invoice-${id}`],
    url: `${APIS.MERCHANT_INVOICE}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["rider-invoice", `rider-invoice-${id}`],
    navigateURL: "/",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.RIDER_INVOICE}${id}/`;
    console.log(values);
    let formData = {};
    console.log(formData, "handle edit");
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Rider Statement
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditRiderInvoiceComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          data={data}
        />
      )}
    </>
  );
};

export default EditRiderInvoice;
